import { createFileRoute, Link } from "@tanstack/react-router";
import welcomeImage from "@/assets/exercise-background-photos/welcome-page-1.png";
import goodHeart from "@/assets/new-logo.svg";
import haseneLogo from "@/assets/HASENE-Logo-1.png";
import gdexaLogo from "@/assets/gdexa.png";
import { Button } from "@/components/ui/button.tsx";
import { FormattedMessage } from "react-intl";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export const Route = createFileRoute("/welcome")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex min-h-screen flex-col gap-6 p-4">
      <div className="relative h-[71vh] min-h-80 max-h-250 w-full rounded-2xl">
        <img
          src={welcomeImage}
          alt="Welcome to HAMD"
          className="w-full h-full object-cover rounded-2xl"
        />

        <div className="absolute top-22 left-0 right-0 px-4 text-center sm:top-26 sm:px-6 md:top-28">
          <h1 className="text-h1 sm:text-hero">
            <FormattedMessage id="app.welcome.title" />
          </h1>
          <p className="mx-auto mt-3 max-w-sm text-body tracking-tight sm:mt-4">
            <FormattedMessage id="app.welcome.description" />
          </p>
        </div>

        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
          <div className="bg-background rounded-full p-5 ">
            <img src={goodHeart} className="w-13 h-13" />
          </div>
        </div>

        <div className="absolute -bottom-8 right-0 transform translate-y-1/2">
          <LanguageSwitcher className="rounded-full" />
        </div>
      </div>

      <div className="flex flex-col space-y-4 pt-9">
        <Link to={"/introduction"}>
          <Button size="default" className="w-full">
            <FormattedMessage id="app.getStarted" />
          </Button>
        </Link>
      </div>
      <div
        dir="ltr"
        className="mt-auto flex flex-col items-center gap-1.5 pb-2"
      >
        <div className="flex items-center gap-2.5 w-full justify-center">
          <div className="h-px w-8 bg-dark-gray/35"></div>
          <span className="text-micro text-dark-gray/35 ">
            <FormattedMessage id="app.poweredBy" defaultMessage="Powered by" />
          </span>
          <div className="h-px w-8 bg-dark-gray/35"></div>
        </div>
        <div className="flex items-center justify-center gap-6">
          <img
            src={haseneLogo}
            alt="Hasene International"
            className="h-9 sm:h-11 object-contain opacity-80"
          />
          <img
            src={gdexaLogo}
            alt="GDEXA"
            className="h-10 sm:h-12 object-contain opacity-80"
          />
        </div>
      </div>
    </div>
  );
}
